import script from "./DatasourceNodeEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasourceNodeEdit.vue?vue&type=script&setup=true&lang=js"

import "./DatasourceNodeEdit.vue?vue&type=style&index=0&id=7a1e66fd&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a1e66fd"]])

export default __exports__